import React from 'react';

export default () => {
  return <h5>Welcome!</h5>;
};
